import * as ko from "knockout";
import { BaseService } from "../_common/_baseService";
import { portalHttpService } from "../_common/httpService";

class RequestCommonsService extends BaseService {
  constructor() {
    super("requestCommons");
  }

  reopenRequest = async (request_id: string, customer_message: string) => {
    await portalHttpService.post<any>(
      `${this.baseApiUrl()}/ReopenRequest`,
      ko.toJSON({ request_id, customer_message }),
    );
  };

  public getRequestServiceOrdersCount = async (request_id: string): Promise<number> => {
    return await portalHttpService.get<number>(`${this.baseApiUrl()}/GetServiceOrdersCount/${request_id}`);
  };

  public getRequestSolutions = async (request_id: string): Promise<any[]> => {
    return await portalHttpService.get<any[]>(`${this.baseApiUrl()}/GetRequestSolutions/${request_id}`);
  };
}

export const requestCommonsService = new RequestCommonsService();
